import type { BaseComponentProps } from "@q4/nimbus-ui";

export interface FilterButtonProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
  disabled?: boolean;
  onClick: () => void;
}

export enum FilterButtonClassName {
  Base = "filter-button",
}
